import React, { useEffect, useState } from "react";
import "../SendMessages/styles.css";
import { v4 as uuid } from "uuid";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import "./doctorslug.scss";
import NoPateintSelected from "./nopatient";
import smsIcon from "../../assets/smsicon.svg";
import CloseIcon from "../../assets/close_icon.png";
import emailIcon from "../../assets/emailicon.svg";
import Commontab from "./commontab";
import { Modal } from "@mui/material";
import PatientTagMore from "./PatientTagMore";
import PatientTag from "./PatientTag";
import SlugListModal from "./SlugListModal";
import Shareconfirm from "./shareconfirmModal";
import SlugMessageSent from "./messagesentModal";
import EmailListModal from "./emailListModal";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

const SlugMessage = (props) => {
  const { doctorId, isDoctorId } = props;
  const [patients, setPatients] = useState([]);
  const [selectedPatients, setSelectedPatients] = useState([]);
  const [searchedPatient, setSearchedPatient] = useState("");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [approvedPatients, setApprovedPatients] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newNumber, setNewNumber] = useState(false);
  const [notFound, setNotFound] = useState("");
  const [nopatient, setnopatient] = useState(false);
  const [updateFlag, setupdateFlag] = useState(false);
  const [openSmsTab, setopenSmsTab] = useState(false);
  const [openSlugList, setopenSlugList] = useState(false);
  const [data, setdata] = useState({});
  const [share, setshare] = useState(false);
  const [sentmodal, setsentmodal] = useState(false);
  const [emailapprovedPatients, setEmailApprovedPatients] = useState([]);
  const [emailpatients, setEmailPatients] = useState([]);
  const [search_string, setsearch_string] = useState("");
  const [emailselectedPatients, setEmailSelectedPatients] = useState([]);
  const [emailcheckedAll, setEmailCheckedAll] = useState(false);
  const [smsBody, setsmsBody] = useState(true);
  const [newEmail, setNewEmail] = useState(false);
  const [notEmailFound, setEmailNotFound] = useState("");
  const [clicked, setclicked] = useState("");
  const currentDoctorID = isDoctorId
    ? doctorId
    : localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const toggleDrawer = () => {
    setSearchedPatient("");
    setsearch_string("");
    setopenSlugList(false);
    let tempPatient = [...patients];
    setCheckedAll(false);
    for (const element of tempPatient) {
      element.selected = false;
    }
    setPatients(tempPatient);

    setSelectedPatients([]);
  };
  const handleBack = () => {
    setshare(false);
    props.toggleDrawer();
  };
  const openSms = (type) => {
    if (type == "email") {
      if (!openSmsTab) setopenSmsTab(!openSmsTab);
      setsmsBody(false);
      setclicked("email");
    } else {
      setopenSmsTab(!openSmsTab);
      setsmsBody(true);
      setclicked("sms");
    }
  };
  useEffect(() => {
    if (props.show) {
      setopenSmsTab(false);
      let token;
      let doctor_id;
      try {
        token = window.localStorage.getItem("id_token");
      } catch (error) {}
      afterLoginApiAxios({
        method: "post",
        url: "/doctor/get-care-group/",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
        data: {
          doctor_id: currentDoctorID,
          appointment_date: "",
          "authorizer-principal-id": {
            user_type: "1",
          },
        },
      })
        .then(function (response) {
          let patientsResp = [];
          let apiResp = response.data.all_patients;
          for (let i = 0; i < apiResp?.length; i++) {
            let tempPatient = {};
            tempPatient["id"] = apiResp[i]["patient_id"];
            tempPatient["name"] = apiResp[i]["patient_name"];
            tempPatient["phone"] = apiResp[i]["patient_number"];
            tempPatient["selected"] = false;
            if (apiResp[i]["patient_name"].split(" ").length > 1) {
              tempPatient["initials"] =
                apiResp[i]["patient_name"].split(" ")[0].charAt(0) +
                apiResp[i]["patient_name"].split(" ")[1].charAt(0);
            } else {
              tempPatient["initials"] = apiResp[i]["patient_name"]
                .split(" ")[0]
                .charAt(0);
            }
            patientsResp.push(tempPatient);
          }
          setPatients(patientsResp);
        })
        .catch((error) => {
          C2CConsole.log(error);
        });
    }
  }, [window.localStorage, props.StaffDocotrId, props.show]);

  useEffect(() => {
    setFilteredPatients(
      patients.filter((patient) => {
        return (
          patient.name.toLowerCase().includes(searchedPatient.toLowerCase()) ||
          patient.phone.includes(searchedPatient)
        );
      })
    );
  }, [searchedPatient, patients]);

  const handleCheckPatientContact = (event) => {
    setLoading(true);
    let patientsAvailable = [...patients];
    let patientsSelected = [...selectedPatients];
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === event.target.value) {
        patientsAvailable[i].selected = event.target.checked;
        if (event.target.checked) {
          if (
            !patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected.push(patientsAvailable[i]);
          }
        } else {
          if (
            patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected = patientsSelected.filter(
              (ps) => ps.id !== patientsAvailable[i].id
            );
          }
        }
      }
    }
    if (patientsSelected.length < patients.length && checkedAll === true) {
      setCheckedAll(false);
    }
    if (patientsSelected.length === patients.length && checkedAll === false) {
      setCheckedAll(true);
    }
    setSelectedPatients(patientsSelected);
    setPatients(patientsAvailable);
    setLoading(false);
  };

  const removeSelectedPatient = (index) => {
    let patientsSelected = [...selectedPatients];
    let patientsAvailable = [...patients];
    patientsSelected = patientsSelected.filter((ps) => ps.id !== index);
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === index) {
        patientsAvailable[i].selected = false;
      }
    }
    if (patientsSelected.length < patients.length && checkedAll === true) {
      setCheckedAll(false);
    }
    setSelectedPatients(patientsSelected);
    setPatients(patientsAvailable);
  };

  const removeApprovedPatient = (e, index) => {
    e.stopPropagation();
    if (smsBody) {
      let patientsApproved = [...approvedPatients];
      patientsApproved = patientsApproved.filter((pa) => pa.id !== index);
      if (patientsApproved.length < patients.length && checkedAll === true) {
        setCheckedAll(false);
      }
      setApprovedPatients(patientsApproved);
      removeSelectedPatient(index);
    } else {
      let patientsApproved = [...emailapprovedPatients];
      patientsApproved = patientsApproved.filter((pa) => pa.id !== index);
      if (
        patientsApproved.length < emailpatients.length &&
        checkedAll === true
      ) {
        setCheckedAll(false);
      }
      setEmailApprovedPatients(patientsApproved);
      emailremoveSelectedPatient(index);
    }
  };

  const patientsFound = (data) => {
    if (smsBody) {
      if (selectedPatients.length > 0) {
        setupdateFlag(true);
        setApprovedPatients([...selectedPatients]);
        setopenSlugList(false);
      } else {
        setApprovedPatients([...selectedPatients]);
      }
    } else {
      if (data.length > 0) {
        setupdateFlag(true);
        setEmailApprovedPatients([...data]);
        setopenSlugList(false);
      } else {
        setEmailApprovedPatients([...data]);
      }
    }
  };

  const closeShareSlug = () => {
    setclicked("");
    setopenSmsTab(false);
    setsmsBody(true);
    props.closeSlugModal();
  };
  const handleCheckAllPatients = (event) => {
    setSearchedPatient("");
    let patientsAvailable = [...patients];
    let patientsSelected = [...selectedPatients];
    setCheckedAll(event.target.checked);
    patientsAvailable.forEach((p) => {
      p.selected = event.target.checked;
      if (event.target.checked) {
        if (!patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected.push(p);
        }
      } else {
        if (patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected = patientsSelected.filter((ps) => ps.id !== p.id);
        }
      }
    });
    setSelectedPatients(patientsSelected);
    setPatients(patientsAvailable);
  };

  const handleNewContact = (e) => {
    if (!isNaN(e.target.value)) {
      if (e.target.value.length < 10) {
        setNotFound("Please Enter Valid Number or Select One");
        setNewNumber(true);
      } else if (e.target.value.length === 10) {
        setNotFound("");
        let newSelectedArr = [
          ...selectedPatients,
          {
            id: uuid(),
            name: e.target.value,
            initials: "N",
            phone: "+91" + e.target.value.substr(-10),
            selected: true,
            isNew: true,
          },
        ];
        setSelectedPatients(newSelectedArr);
      } else {
        setNotFound("Please Enter Valid Number or Select One");
        setNewNumber(true);
      }
    } else {
      setNotFound("No Number found with this Name");
      setNewNumber(true);
    }
    e.target.value = "";
    setSearchedPatient("");
  };
  const handleEmailNewContact = (e) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let validornot = re.test(e.target.value);

    if (validornot) {
      setEmailNotFound("");
      let newSelectedArr = [
        ...emailselectedPatients,
        {
          id: uuid(),
          email: e.target.value,
          initials: "N",
          name: e.target.value,
          selected: true,
          isNew: true,
        },
      ];
      setEmailSelectedPatients(newSelectedArr);
    } else {
      setEmailNotFound("Please Enter Valid Email or Select One");
      setNewEmail(true);
    }
    e.target.value = "";
    setsearch_string("");
  };

  const sharePopClose = () => {
    setSelectedPatients([]);
    setSelectedTitle("");
    setSearchedPatient("");
    setApprovedPatients([]);
    setCheckedAll(false);
    setEmailSelectedPatients([]);
    setEmailApprovedPatients([]);
    setEmailCheckedAll(false);
    setupdateFlag(false);
    let patientsAvailable = [...patients];
    patientsAvailable.forEach((p) => {
      p.selected = false;
    });
    setPatients(patientsAvailable);
    let patientsEmailAvailable = [...emailpatients];
    patientsEmailAvailable.forEach((p) => {
      p.selected = false;
    });
    setEmailPatients(patientsEmailAvailable);
    setshare(false);
  };
  const handleSubmit = () => {
    let token;

    try {
      token = window.localStorage.getItem("id_token");
    } catch (error) {}
    if (smsBody) {
      if (approvedPatients.length > 0) {
        let finalRequestData = [];
        for (let i = 0; i < approvedPatients.length; i++) {
          let tempMess = {
            patient_phone_no: approvedPatients[i]["phone"],
            patient_id: approvedPatients[i]["id"],
          };
          if (approvedPatients[i]["isNew"]) {
            tempMess["patient_new"] = true;
          } else {
            tempMess["patient_new"] = false;
          }
          finalRequestData.push(tempMess);
        }
        let data = {
          doctor_id: currentDoctorID,
          preset_message: selectedTitle,
          request: finalRequestData,
          token: token,
        };
        setdata(data);
      }
    } else {
      if (emailapprovedPatients.length > 0) {
        let finalRequestData = [];
        for (let i = 0; i < emailapprovedPatients.length; i++) {
          finalRequestData.push(emailapprovedPatients[i]["email"]);
        }
        let data = {
          doctor_id: currentDoctorID,
          request: finalRequestData,
          token: token,
        };
        setdata(data);
      }
    }
    setshare(true);
    props.toggleDrawer();
  };
  const emailremoveSelectedPatient = (index) => {
    let patientsSelected = [...emailselectedPatients];
    let patientsAvailable = [...emailpatients];
    patientsSelected = patientsSelected.filter((ps) => ps.id !== index);
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === index) {
        patientsAvailable[i].selected = false;
      }
    }
    if (patientsSelected.length < emailpatients.length && checkedAll === true) {
      setEmailCheckedAll(false);
    }
    setEmailSelectedPatients(patientsSelected);
    setEmailPatients(patientsAvailable);
  };

  const emailhandleCheckPatientContact = (event) => {
    let patientsAvailable = [...emailpatients];
    let patientsSelected = [...emailselectedPatients];
    for (var i = 0; i < patientsAvailable.length; i++) {
      if (patientsAvailable[i].id === event.target.value) {
        patientsAvailable[i].selected = event.target.checked;
        if (event.target.checked) {
          if (
            !patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected.push(patientsAvailable[i]);
          }
        } else {
          if (
            patientsSelected.some((ps) => ps.id === patientsAvailable[i].id)
          ) {
            patientsSelected = patientsSelected.filter(
              (ps) => ps.id !== patientsAvailable[i].id
            );
          }
        }
      }
    }
    if (patientsSelected.length < emailpatients.length && checkedAll === true) {
      setEmailCheckedAll(false);
    }
    if (
      patientsSelected.length === emailpatients.length &&
      checkedAll === false
    ) {
      setEmailCheckedAll(true);
    }
    setEmailSelectedPatients(patientsSelected);
    setEmailPatients(patientsAvailable);
  };

  const emailhandleCheckAllPatients = (event) => {
    let patientsAvailable = [...emailpatients];
    let patientsSelected = [...emailselectedPatients];
    setEmailCheckedAll(event.target.checked);
    patientsAvailable.forEach((p) => {
      p.selected = event.target.checked;
      if (event.target.checked) {
        if (!patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected.push(p);
        }
      } else {
        if (patientsSelected.some((ps) => ps.id === p.id)) {
          patientsSelected = patientsSelected.filter((ps) => ps.id !== p.id);
        }
      }
    });
    setEmailSelectedPatients(patientsSelected);
    setEmailPatients(patientsAvailable);
  };
  useEffect(() => {
    if (props.show) {
      fetchPatientList(search_string);
    }
  }, [search_string, props.show]);
  const fetchPatientList = (search_string) => {
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
    } catch (error) {}

    afterLoginApiAxios({
      method: "post",
      url: "/doctor/get-care-email",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        doctor_id: currentDoctorID,
        search_string: search_string ? search_string : "",
      },
    })
      .then(function (response) {
        let patientsResp = [];
        let apiResp = response.data.all_patients;
        for (let i = 0; i < apiResp?.length; i++) {
          let tempPatient = {};
          tempPatient["id"] = apiResp[i]["patient_id"];
          tempPatient["name"] = apiResp[i]["patient_name"];
          tempPatient["email"] = apiResp[i]["email"];
          tempPatient["selected"] = false;
          if (apiResp[i]["patient_name"].split(" ").length > 1) {
            tempPatient["initials"] =
              apiResp[i]["patient_name"].split(" ")[0].charAt(0) +
              apiResp[i]["patient_name"].split(" ")[1].charAt(0);
          } else {
            tempPatient["initials"] = apiResp[i]["patient_name"]
              .split(" ")[0]
              .charAt(0);
          }
          patientsResp.push(tempPatient);
        }
        setEmailPatients(patientsResp);
      })
      .catch((error) => {
        C2CConsole.log(error);
      });
  };

  const getDivClassName = (type) => {
    if (clicked === type) {
      return `clicked rounded`;
    } else {
      return `border rounded`;
    }
  };

  return (
    <>
      {props.show ? (
        <Modal open={props.show} onClose={closeShareSlug}>
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="slugmessage-modal-wrapper">
              <div
                className={`${
                  smsBody ? "default-slug-modal" : "email-slug-list"
                }`}
              >
                {!openSlugList ? (
                  <>
                    <div className=" share-link-modal-wrapper px-2">
                      <div className="p-2 border-bottom">
                        <span className="heading-style">Share Link </span>{" "}
                        <span
                          className="float-right cursor-pointer"
                          onClick={closeShareSlug}
                          style={{ fontSize: "1rem", marginTop: "10px" }}
                        >
                          <img className="close-img" src={CloseIcon} alt="X" />
                        </span>
                      </div>
                      <div className="my-3 px-2 d-flex justify-content-center slug-share-icons ">
                        <div
                          className={`p-3 mr-3 d-flex justify-content-center flex-column ${getDivClassName(
                            "sms"
                          )}`}
                          onClick={() => openSms("sms")}
                        >
                          <img
                            className=""
                            src={smsIcon}
                            style={{ height: "50px", width: "52px" }}
                          />
                          <span>C2C SMS</span>
                        </div>
                        <div
                          className={`p-3  d-flex justify-content-center flex-column ${getDivClassName(
                            "email"
                          )}`}
                          onClick={() => openSms("email")}
                        >
                          <img
                            className=""
                            src={emailIcon}
                            style={{ height: "50px", width: "52px" }}
                          />
                          <span>C2C Email</span>
                        </div>
                      </div>
                      {openSmsTab && (
                        <Commontab
                          approvedPatients={
                            smsBody ? approvedPatients : emailapprovedPatients
                          }
                          PatientTag={PatientTag}
                          removeApprovedPatient={removeApprovedPatient}
                          PatientTagMore={PatientTagMore}
                          handleSubmit={handleSubmit}
                          openList={() => setopenSlugList(true)}
                          name={props.name}
                          slug={props.slug}
                          smsBody={smsBody}
                          phone={props.phone}
                        />
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    {smsBody ? (
                      <>
                        <SlugListModal
                          onHide={toggleDrawer}
                          setSearchedPatient={setSearchedPatient}
                          selectedPatients={selectedPatients}
                          handleNewContact={handleNewContact}
                          removeSelectedPatient={removeSelectedPatient}
                          handleCheckAllPatients={handleCheckAllPatients}
                          handleCheckPatientContact={handleCheckPatientContact}
                          patientsFound={patientsFound}
                          loading={loading}
                          searchedPatient={searchedPatient}
                          newNumber={newNumber}
                          setNewNumber={setNewNumber}
                          notFound={notFound}
                          checkedAll={checkedAll}
                          filteredPatients={filteredPatients}
                          updateFlag={updateFlag}
                        />
                      </>
                    ) : (
                      <>
                        <EmailListModal
                          setsearch_string={(data) => setsearch_string(data)}
                          search_string={search_string}
                          onHide={toggleDrawer}
                          patientsFound={patientsFound}
                          loading={loading}
                          newEmail={newEmail}
                          setNewEmail={setNewEmail}
                          notEmailFound={notEmailFound}
                          updateFlag={updateFlag}
                          emailpatients={emailpatients}
                          emailselectedPatients={emailselectedPatients}
                          emailremoveSelectedPatient={
                            emailremoveSelectedPatient
                          }
                          emailhandleCheckAllPatients={
                            emailhandleCheckAllPatients
                          }
                          emailhandleCheckPatientContact={
                            emailhandleCheckPatientContact
                          }
                          handleEmailNewContact={handleEmailNewContact}
                          checkedAll={emailcheckedAll}
                        />
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal>
      ) : null}
      <NoPateintSelected
        show={nopatient}
        type="nopatientselected"
        handleClose={() => setnopatient(false)}
      />
      <Shareconfirm
        show={share}
        data={data}
        name={props.name}
        slug={props.slug}
        phone={props.phone}
        handleClose={sharePopClose}
        opensent={() => setsentmodal(true)}
        handleBack={handleBack}
        smsBody={smsBody}
      />
      <SlugMessageSent
        show={sentmodal}
        okayClickHandler={() => setsentmodal(false)}
      />
    </>
  );
};

export default SlugMessage;
